package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.lightweightform.kotlin.type.validator.ValidationError

object FreeTextValidator {

    private val FREE_TEXT_PATTERN = Regex(
        "[\\s\\w!\"#$%&'()*+,\\-./:;<=>?@\\[\\]^_`{|}~\\u005C\\u00A1-\\u00FF]*"
    )

    val validateFreeText = fun(value: String): ValidationError? {
        return if (value.isNotEmpty() && !FREE_TEXT_PATTERN.matches(value)) ValidationError(
            CustomErrorCodes.FREE_TEXT_INVALID_CHARACTER.code
        )
        else null
    }
}
